import { memo } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from "@fortawesome/free-solid-svg-icons/faClipboardList";
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectOrders, selectSelectedOrderUnvId, selectOrdersFilter, selectGobackReportingsUrl } from '@pages/orders/store/selectors';
import LoadingElement from 'components/base-elements/loading/LoadingElement';
import OrderItem from '@pages/orders/orders-page/list-area/order-item/OrderItem';
import { getTileFilterText } from '@api/shipping-data/types/TileFilter';



interface ListAreaProps {
	isSmallScreen: boolean,
	pagingLoading: boolean,
}


export const ListArea = (props: ListAreaProps) => {
	const { isSmallScreen, pagingLoading } = props;

	const selectedOrderUnvId = useSelector(selectSelectedOrderUnvId);
	const gobackReportingUrl = useSelector(selectGobackReportingsUrl);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const orders = useSelector(selectOrders);
	const ordersFilter = useSelector(selectOrdersFilter);


	if (!orders || orders.length === 0) return (
		<div className="list-area">
			<div className="list-area-title">
				<FontAwesomeIcon className="list-area-icon" icon={faClipboardList} />
				<p>{`Objednávky${ordersFilter !== null ? ` - ${getTileFilterText(ordersFilter)}` : ''}`}</p>
			</div>
			<p className='list-empty'>Žádné záznamy</p>
		</div>
	);
	

	return (
		<div className="list-area">

			<div className="list-area-title">
				<FontAwesomeIcon className="list-area-icon" icon={faClipboardList} />
				<p>{`Objednávky${ordersFilter !== null ? ` - ${getTileFilterText(ordersFilter)}` : ''}`}</p>
			</div>
			
			{orders && orders.map(x =>
				<OrderItem
					item={x}
					dateWithoutTime={dateWithoutTime}
					isSmallScreen={isSmallScreen}
					gobackReportingUrl={gobackReportingUrl}
					isSelected={selectedOrderUnvId && x.orderStatistics ? selectedOrderUnvId === x.orderStatistics.unversionedSystemId : false}
					key={`list-order-item-${x.orderStatistics ? x.orderStatistics.systemId : '-'}`} />)}

			{pagingLoading &&
				<LoadingElement />}
		
		</div>
	)
}

export default memo(ListArea);